export default {
  home: {
    title: '首页',
    welcome: '欢迎来到我们的网站',
    description: '这是一个基于 Rails 和 Vue3 的现代化 Web 应用',
    getStarted: '开始使用',
    learnMore: '了解更多'
  },
  header: {
    home: '首页',
    features: '功能',
    pricing: '价格',
    about: '关于',
    login: '登录',
    register: '注册',
    dashboard: '控制台',
    profile: '个人资料',
    settings: '设置',
    logout: '退出登录',
    tiktok: '抖音营销'
  },
  footer: {
    copyright: '版权所有',
    terms: '服务条款',
    privacy: '隐私政策',
    contact: '联系我们'
  },
  mobile: {
    menu: '菜单',
    toggleMenu: '切换菜单',
    closeMenu: '关闭菜单',
    openMenu: '打开菜单'
  },
  pricing: {
    title: {
      main: '选择适合您的',
      highlight: '套餐方案'
    },
    description: '我们提供灵活的价格方案，满足不同规模企业的需求\n随时可以升级或降级您的套餐',
    plans: {
      basic: {
        name: '基础版',
        price: '¥299',
        period: '/月',
        description: '适合个人或小型团队使用',
        features: {
          apiCalls: '每月1000次API调用'
        },
        cta: '选择基础版'
      },
      pro: {
        name: '专业版',
        badge: '最受欢迎',
        price: '¥899',
        period: '/月',
        description: '适合中型企业和专业团队',
        features: {
          apiCalls: '每月5000次API调用',
          analysis: '高级数据分析',
          projects: '20个项目',
          support: '优先客服支持'
        },
        cta: '选择专业版'
      },
      enterprise: {
        name: '企业版',
        price: '¥1999',
        period: '/月',
        description: '适合大型企业和高级需求',
        features: {
          apiCalls: '无限API调用'
        },
        cta: '选择企业版'
      }
    },
    faq: {
      title: '常见问题',
      questions: {
        choosePlan: {
          question: '如何选择合适的套餐？',
          answer: '您可以根据您的团队规模和需求选择合适的套餐。基础版适合个人或小型团队，专业版适合中型企业，企业版则适合大型企业和有特殊需求的客户。您可以随时升级或降级您的套餐。'
        },
        customPlan: {
          question: '是否支持自定义套餐？',
          answer: '是的，我们提供企业定制服务。如果标准套餐无法满足您的需求，请联系我们的销售团队，我们将为您量身定制解决方案。'
        },
        apiCount: {
          question: '如何计算API调用次数？',
          answer: '每次向我们的服务器发送请求都计算为一次API调用。我们的系统会实时统计您的使用情况，您可以在控制面板中查看详细的使用记录。'
        },
        refund: {
          question: '是否支持退款？',
          answer: '我们提供7天无理由退款保证。如果您对服务不满意，可以在购买后7天内申请全额退款。超过7天的退款请联系客服协商处理。'
        }
      }
    }
  }
}
